import { render } from "./RamificacaoSelecao.vue?vue&type=template&id=36249d46&scoped=true&ts=true"
import script from "./RamificacaoSelecao.vue?vue&type=script&lang=ts"
export * from "./RamificacaoSelecao.vue?vue&type=script&lang=ts"

import "./RamificacaoSelecao.vue?vue&type=style&index=0&id=36249d46&scoped=true&lang=css"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36249d46"]])

export default __exports__